import MoveTo from './MoveTo'

export default class PlayerMoveToWithSpeed extends MoveTo {
    constructor(player, speed, position) {
        super(player, null, position, {speed: speed});
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Movements/PlayerMoveToWithSpeed.js
 **/